import client from '@/http'

const loadAll = (context) => {
  client.get(
    'library'
  ).then(
    (res) => {
      context.commit('SET_ITEMS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, id) => {
  client.get(
    `library/${id}`
  ).then(
    (res) => {
      context.commit('SET_ITEM', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `library/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      'library', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, id) => {
  client.delete(`library/${id}`).then(
    () => context.commit('REMOVE', id)
  ).catch(
    (err) => console.error(err)
  )
}

export default {
  save,
  load,
  remove,
  loadAll
}
